export enum RecordingStates {
  STOPED,
  PLAYING,
  PAUSED,
}
